import Title from './main.vue'
export default Title
